/**
 * LinkedChevrons - the Squad Mode mark (ruled 2026-10-23): two linked chevrons in the team's livery. The bracket
 * corners and dot are the TARGET reticle, so the squad never wears them. One drawing for every place a person is named.
 */
import type { Livery } from '../../engine/roster/team';
import { liveryStyle } from '../../utils/liveryStyle';

/** The two chevrons, for an SVG that already stands somewhere (the map's name pill). */
export const CHEVRONS_PATH = 'M1.5 2.5l3.5 3.5-3.5 3.5M6.5 2.5l3.5 3.5-3.5 3.5';

export default function LinkedChevrons({ livery, size = 12 }: { livery?: Livery | null; size?: number }) {
  return (
    <span
      title="In Squad Mode"
      role="img"
      aria-label="In Squad Mode"
      data-testid="mark-squad-mode"
      style={liveryStyle(livery)}
    >
      <svg width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path
          d={CHEVRONS_PATH}
          stroke="var(--livery, var(--accent))"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
